import store from '../store'

export default function permission ({ next, store, router, to, from }) {
  // Get the required permission from route meta
  console.log(next, store, router, to, from)
  const requiredPermission = to.meta.permission

  if (!requiredPermission) {
    // No permission required, allow access
    return next()
  }

  // Get user permissions safely
  const userPermissions = store.getters['Auth/getPermissions'] || []
  const isAdmin = store.getters['Auth/isAdmin'] || false

  // Check if user has the required permission
  const hasPermission = userPermissions.includes(requiredPermission) || isAdmin

  if (hasPermission) {
    next()
  } else {
    // Redirect to unauthorized page or show error
    next({
      name: 'dashboard',
      query: {
        error: 'unauthorized',
        message: 'You do not have permission to access this page'
      }
    })
  }
}
